import { ChangeEvent, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { ReactComponent as Svg700 } from '../../aassets/ic/product/ic_product_700.svg';
import { ReactComponent as Svg700Active } from '../../aassets/ic/product/ic_product_700_active.svg';
import { ReactComponent as SvgDemo } from '../../aassets/ic/product/ic_product_demo.svg';
import { ReactComponent as SvgDemoActive } from '../../aassets/ic/product/ic_product_demo_active.svg';
import { ReactComponent as SvgEn } from '../../aassets/ic/product/ic_product_english.svg';
import { ReactComponent as SvgEnActive } from '../../aassets/ic/product/ic_product_english_active.svg';
import { ReactComponent as SvgKamuti } from '../../aassets/ic/product/ic_product_kamuti.svg';
import { ReactComponent as SvgKamutiActive } from '../../aassets/ic/product/ic_product_kamuti_active.svg';
import { ReactComponent as SvgMiluli } from '../../aassets/ic/product/ic_product_miluli.svg';
import { ReactComponent as SvgMiluliActive } from '../../aassets/ic/product/ic_product_miluli_active.svg';
import { ReactComponent as SvgInfo } from '../../aassets/ic/Info.svg';
import s from './exersizes.module.scss';
//@ts-ignore

import { ProductWithDomains, ReactPressVars, SelectDomain } from '../../types';
import Times from '../../components/exersize/Times/Times';

interface Props {
	wpdata: ReactPressVars;
	isDev: boolean;
}
const Exersizes = ({ wpdata, isDev }: Props) => {
	const products = useLoaderData() as ProductWithDomains[];

	const [tabIndex, setTabIndex] = useState(0);

	const [selectDoms, setSelectDoms] = useState<SelectDomain[]>(
		Object.values(products)[0].domains
	);

	const onTabSelect = (index: number, lastIndex: number, event: Event) => {
		setTabIndex(index);
		setSelectDoms(Object.values(products)[index].domains);
	};

	const tabs = Object.values(products).map((p, i) => (
		<Tab
			className={s.rTabs_tab}
			selectedClassName={s.rTabs_tab__selected}
			key={`tab${i}`}>
			{p.name === 'DEMO' ? (
				tabIndex === i ? (
					<SvgDemoActive />
				) : (
					<SvgDemo />
				)
			) : p.name.includes('700') ? (
				tabIndex === i ? (
					<Svg700Active />
				) : (
					<Svg700 />
				)
			) : p.name === 'כמותי' ? (
				tabIndex === i ? (
					<SvgKamutiActive />
				) : (
					<SvgKamuti />
				)
			) : p.name === 'אנגלית' ? (
				tabIndex === i ? (
					<SvgEnActive />
				) : (
					<SvgEn />
				)
			) : tabIndex === i ? (
				<SvgMiluliActive />
			) : (
				<SvgMiluli />
			)}

			<span className={s.rTabs_tab_span}>{p.name}</span>
			<div className={s.tbrdr} />
		</Tab>
	));

	const updateChoosenCats = (
		e: ChangeEvent<HTMLInputElement>,
		domainIndex: number,
		categoryId: number,
		catsIsMultyselect: boolean,
		subcategoryId?: number,
		subcatsIsMultyselect?: boolean,
		domMultyselect?: boolean
	) => {
		const newDoms = [...selectDoms];

		if (!domMultyselect) {
			newDoms.forEach((dom, i) => {
				if (i !== domainIndex) {
					dom.categories.forEach((cat) => {
						cat.isChoosen = false;
						if (Object.hasOwn(cat, 'subcategories')) {
							cat.subcategories.forEach((sc) => {
								sc.isChoosen = false;
							});
						}
					});
				}
			});
		}

		const newCats = selectDoms[domainIndex].categories;

		if (!catsIsMultyselect) {
			//cats loop
			for (let i = 0; i < newCats.length; i++) {
				// found current category
				if (newCats[i].id === categoryId) {
					if (subcategoryId) {
						//current subcats loop
						const subcats = newCats[i].subcategories;

						let checkedCount = 0;

						for (let j = 0; j < subcats.length; j++) {
							if (subcats[j].id === subcategoryId) {
								newCats[i].subcategories[j].isChoosen =
									e.target.checked;
							} else if (!subcatsIsMultyselect) {
								newCats[i].subcategories[j].isChoosen = false;
							}
							checkedCount += newCats[i].subcategories[j]
								.isChoosen
								? 1
								: 0;
						}
						newCats[i].isChoosen = checkedCount > 0 ? true : false;
					} else {
						newCats[i].isChoosen = e.target.checked;
					}
				} else {
					newCats[i].isChoosen = false;
					if (
						newCats[i].subcategories &&
						newCats[i].subcategories.length > 0
					) {
						newCats[i].subcategories.forEach((subc) => {
							subc.isChoosen = false;
						});
					}
				}
			}
		} else {
			for (let i = 0; i < newCats.length; i++) {
				if (newCats[i].id === categoryId) {
					if (subcategoryId) {
						//current subcats loop
						const subcats = newCats[i].subcategories;

						let checkedCount = 0;

						for (let j = 0; j < subcats.length; j++) {
							if (subcats[j].id === subcategoryId) {
								newCats[i].subcategories[j].isChoosen =
									e.target.checked;
							} else if (!subcatsIsMultyselect) {
								newCats[i].subcategories[j].isChoosen = false;
							}
							checkedCount += newCats[i].subcategories[j]
								.isChoosen
								? 1
								: 0;
						}
						newCats[i].isChoosen = checkedCount > 0 ? true : false;
					} else {
						newCats[i].isChoosen = e.target.checked;
					}

					break;
				}
			}
		}

		if (!catsIsMultyselect) {
			newDoms.forEach((dom, i) => {
				if (i !== domainIndex) {
					const newCats = selectDoms[i].categories;
					newCats.forEach((cat, i) => {
						cat.isChoosen = false;
					});
				}
			});
		}
		newDoms[domainIndex].categories = newCats;

		setSelectDoms(newDoms);
	};

	const selectedCatsCount = selectDoms.reduce((acc, d) => {
		d.categories.forEach((c) => {
			if (c.isChoosen) {
				if (Object.hasOwn(c, 'subcategories')) {
					c.subcategories.forEach((sc) => {
						if (sc.isChoosen) {
							acc++;
						}
					});
				} else {
					acc++;
				}
			}
		});
		return acc;
	}, 0);

	const getSubjects = () => {
		let subjects = new Array<string>();
		selectDoms.forEach((d) => {
			d.categories.forEach((c) => {
				if (c.isChoosen) {
					if (Object.hasOwn(c, 'subcategories')) {
						c.subcategories.forEach((sc) => {
							if (sc.isChoosen && sc.subjects.length > 0) {
								subjects.push(sc.subjects);
							}
						});
					} else {
						if (c.isChoosen && c.subjects.length > 0) {
							subjects.push(c.subjects);
						}
					}
				}
			});
		});
		return subjects.length > 0 ? subjects : undefined;
	};
	const subjects = getSubjects();

	const panels = Object.values(products).map((p, i) => {
		const catMultisielect = p.catMultyselect;
		const subcatsMultiselect = p.subcatMultyselect;
		const domMultyselect = p.domMultyselect;
		// const catMultisielect = true;
		// const subcatsMultiselect = true;
		// const domMultyselect = false;
		const isMultyDomain = p.domains.length > 1;
		const is700 = p.name.includes('700');

		return (
			<TabPanel
				className={s.rTabs_tabPanel}
				selectedClassName={s.rTabs_tabPanel__selected}
				key={`tpanel${i}`}>
				<ul className={s.domsUL}>
					{p.domains.map((dom, j) => (
						<li
							className={isMultyDomain ? s.domLI_mult : s.domLI}
							key={`dom${j}`}>
							<ul
								className={
									isMultyDomain ? s.catsUl_mult : s.catsUl
								}>
								{dom.categories.map((c, k) => {
									if (c.subcategories) {
										const currSubcats = c.subcategories.map(
											(subcat, sub_ind) => (
												<li
													className={s.subCatLI}
													key={`${p.name}inULs${subcat.name}_${sub_ind}`}>
													<input
														className={s.inp}
														name="subcategory"
														id={`subcatInp${subcat.id}`}
														type="checkbox"
														value={subcat.id}
														onChange={(e) => {
															p.is_purchased &&
																updateChoosenCats(
																	e,
																	j,
																	c.id,
																	catMultisielect,
																	subcat.id,
																	subcatsMultiselect,
																	domMultyselect
																);
														}}
														disabled={
															!p.is_purchased ||
															subcat.isDisabled
														}
														checked={
															(p.is_purchased &&
																subcat.isChoosen) ||
															false
														}
													/>
													<label
														htmlFor={`subcatInp${subcat.id}`}
														className={s.lbl}>
														{`${subcat.name}${
															is700 ? ' 700' : ''
														}`}
													</label>
												</li>
											)
										);
										return (
											<li
												className={s.subCatLI}
												key={`${p.name}inUL${c.id}_${k}`}>
												<ul className={s.subcUL}>
													<h3 className={s.ul_title}>
														{c.name}
													</h3>

													{currSubcats}
												</ul>
											</li>
										);
									} else
										return (
											<li
												className={s.subCatLI}
												key={`inUL${c.id}_${k}`}>
												<h3
													className={`${s.ul_title} ${s.ul_title__single}`}>
													{c.name}
												</h3>

												<input
													className={s.inp}
													name="category"
													id={`catInp${c.id}`}
													type="checkbox"
													value={c.id}
													onChange={(e) => {
														p.is_purchased &&
															updateChoosenCats(
																e,
																j,
																c.id,
																catMultisielect
															);
													}}
													disabled={
														!p.is_purchased ||
														c.isDisabled
													}
													checked={
														(p.is_purchased &&
															c.isChoosen) ||
														false
													}
												/>
												<label
													htmlFor={`catInp${c.id}`}
													className={s.lbl}>
													{`${c.name}${
														is700 ? ' 700' : ''
													}`}
												</label>
											</li>
										);
								})}
							</ul>
						</li>
					))}
				</ul>
				{subjects && (
					<div className={s.finfo}>
						<SvgInfo />
						<div className={s.finfo_subjs}>
							{subjects.map((subj, i) => (
								<div
									className={s.finfo_subjs_i}
									key={`${p.name}subj${i}`}>
									{subj}
								</div>
							))}
						</div>
					</div>
				)}
				<div className={s.ffooter}>
					<div className={s.ffooter_count}>
						<p>
							<b>{selectedCatsCount}</b> תרגולים נבחרו סה״כ
						</p>
						{p.name.includes('DEMO') && (
							<div className={s.demo_notice}>
								<p>
									לתשומת ליבך, בגרסת ה-Demo לא ניתן להגדיר את
									משך הזמן המוקצב לשאלה, אך ניתן לתרגל ללא
									הגבלת זמן לשאלה.
								</p>
								<p>
									ביחידות הלימוד האחרות תהיה באפשרותך לבחור את
									משך הזמן המוקצב לשאלה.
								</p>
							</div>
						)}
					</div>
				</div>
			</TabPanel>
		);
	});

	return (
		<section className={s.rt}>
			<div className={s.cnt}>
				<div className={s.cnt_top}>
					<h2 className={s.title}>יחידות תרגול</h2>
				</div>
				<div className={s.cnt_wrap}>
					<Tabs
						className={s.rTabs}
						selectedIndex={tabIndex}
						onSelect={onTabSelect}>
						<TabList className={s.rTabs_tabList}>{tabs}</TabList>

						{panels}
					</Tabs>
					<Times
						selectDoms={selectDoms}
						setSelectDoms={setSelectDoms}
						productID={Object.values(products)[tabIndex].id}
						is_purchased={
							Object.values(products)[tabIndex].is_purchased
						}
						isDemo={Object.values(products)[tabIndex].name.includes(
							'DEMO'
						)}
						url={Object.values(products)[tabIndex].url}
					/>
				</div>
			</div>
		</section>
	);
};
export default Exersizes;
